import {
  OrganisationDetailsContainer,
  OrganisationDetailsItem,
} from "./OrganisationDetails.styles";
import React, { Fragment } from "react";
import { autoFormatValue } from "../../../utilities/UnitsAndKeys/convertUnit";

export const OrganisationDetails = ({ organisation, summary }) => {
  return (
    <OrganisationDetailsContainer>
      {organisation && organisation.childCount && (
        <OrganisationDetailsItem>
          <div>
            <b>{organisation.childCount}</b> Campuses
          </div>
        </OrganisationDetailsItem>
      )}
      <OrganisationDetailsItem>
        <div>
          <b>High School</b> Type
        </div>
      </OrganisationDetailsItem>
      {summary && summary.peakSolarCapacity ? (
        <OrganisationDetailsItem>
          <div>
            <b>{autoFormatValue(summary.peakSolarCapacity, "peakCapacity")}</b>{" "}
            Peak Solar Capacity
          </div>
        </OrganisationDetailsItem>
      ) : null}
      {summary && summary.affectedCapacity ? (
        <OrganisationDetailsItem>
          <div>
            <b>{autoFormatValue(summary.affectedCapacity, "peakCapacity")}</b>{" "}
            Affected Capacity
          </div>
        </OrganisationDetailsItem>
      ) : null}
    </OrganisationDetailsContainer>
  );
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/OrganisationDetails/OrganisationDetails.js